import React from "react";
import { FaAndroid, FaAppStoreIos, FaChrome, FaFirefoxBrowser, FaGlobe } from "react-icons/fa";
import { AppEntry, AppEntryType } from "../../types/PublicListing";

const TYPE_ICONS: Record<AppEntryType, React.ReactNode> = {
  "chrome-extension": <FaChrome />,
  "firefox-addon": <FaFirefoxBrowser />,
  "ios-app": <FaAppStoreIos />,
  "android-app": <FaAndroid />,
  "web-app": <FaGlobe />,
};

interface CompanyAppsProps {
  appEntries: AppEntry[];
}

const CompanyApps: React.FC<CompanyAppsProps> = ({ appEntries }) => {
  if (appEntries.length === 0) return null;

  return (
    <div className="company-apps">
      <div className="section-title">Apps</div>
      <div className="app-list">
        {appEntries.map((entry, index) => (
          <a
            key={index}
            href={entry.url}
            target="_blank"
            rel="noopener noreferrer"
            className="app-pill"
          >
            <span className="app-pill-icon">{TYPE_ICONS[entry.type]}</span>
            <span className="app-pill-name">{entry.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default CompanyApps;
